export default "__VITE_ASSET__BUau1Srr__"